<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd"
				d="M2.4684 7.37479C2.46851 3.49164 5.61646 0.34375 9.49965 0.34375C13.3829 0.34375 16.5309 3.49175 16.5309 7.375L16.5307 7.42624V8.15625C16.5307 10.3678 17.3651 12.3827 18.7375 13.9061C18.911 14.0986 18.9776 14.3646 18.9156 14.6162C18.8535 14.8678 18.6707 15.0722 18.4276 15.1619C16.8193 15.7557 15.1356 16.1936 13.3951 16.4575C13.4022 16.5541 13.4059 16.6517 13.4059 16.75C13.4059 18.9074 11.657 20.6562 9.49965 20.6562C7.34228 20.6562 5.5934 18.9074 5.5934 16.75C5.5934 16.6517 5.59704 16.5542 5.60422 16.4576C3.86352 16.1937 2.17971 15.7557 0.571249 15.1619C0.328163 15.0722 0.145387 14.8678 0.0833094 14.6162C0.0212316 14.3646 0.0879296 14.0986 0.261367 13.9061C1.6338 12.3827 2.46819 10.3678 2.46819 8.15625L2.4684 7.37479ZM7.15819 16.6451C7.15667 16.6798 7.1559 16.7148 7.1559 16.75C7.1559 18.0444 8.20523 19.0938 9.49965 19.0938C10.7941 19.0938 11.8434 18.0444 11.8434 16.75C11.8434 16.7148 11.8426 16.6798 11.8411 16.645C11.0697 16.7145 10.2886 16.75 9.49944 16.75C8.71042 16.75 7.92949 16.7145 7.15819 16.6451Z"
				:fill="color" 
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgNotifications',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped>

</style>